/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getBtsHistoryActions, {
    getBtsHistoryTypes,
} from '../../../redux/collectData/getBtsHistory'
import { Get } from '../../../serveur/axios'

function* getBtsHistorySagas() {
    try {
        const res = yield Get(`csv/bts_data/historique_file`)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getBtsHistoryActions.getBtsHistorySuccess(res.data.data)
                ),
            ])
        } else {
            yield put(getBtsHistoryActions.getBtsHistoryFailure(res))
        }
    } catch (error) {
        yield put(getBtsHistoryActions.getBtsHistoryFailure(error))
    }
}

export function* getBtsHistorySaga() {
    yield takeLatest(
        getBtsHistoryTypes.GET_BTS_HISTORY_REQUEST,
        getBtsHistorySagas
    )
}
